import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Stack, Typography } from '@mui/material';
import { Theme } from '@mui/system';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { SettingsContext } from '../../store/SettingsContext';
import { buildURL, getServiceStatusColor, getServiceStatusName } from '../../utils/common';

type DashboardMyAccountsServicesListProps = {
    subscriber: any;
    theme: Theme;
};

const DashboardMyAccountsServicesList = (props: DashboardMyAccountsServicesListProps) => {
    const { subscriber, theme } = props;
    const settingsContext = useContext(SettingsContext);

    const serviceKeys = settingsContext?.services
        ? Object.keys(settingsContext.services).filter((key: string) => settingsContext.services[key].visible === true)
        : [];

    return (
        <Box sx={{ mt: 1 }}>
            <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 700, mb: 1 }}>
                Services
            </Typography>
            <Stack spacing={0}>
                {serviceKeys.map((key: string) => {
                    const svc = settingsContext!.services[key];
                    const serviceKey = svc.serviceNameKey || key;
                    const paletteKey = getServiceStatusColor(subscriber, serviceKey, settingsContext!.services[serviceKey].alwaysActive);
                    const statusName = getServiceStatusName(subscriber, serviceKey, settingsContext!.services[serviceKey].alwaysActive);
                    const paletteSlot = paletteKey
                        ? theme.palette[paletteKey as 'success' | 'error' | 'warning' | 'info' | 'primary']
                        : null;
                    const statusHex =
                        paletteSlot && typeof paletteSlot === 'object' && 'main' in paletteSlot
                            ? paletteSlot.main
                            : theme.palette.primary.main;

                    const label = svc.name.toUpperCase();
                    const inner = (
                        <>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                                    {svc.icon(
                                        getServiceStatusColor(subscriber, serviceKey, settingsContext!.services[serviceKey].alwaysActive),
                                    )}
                                </Box>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: 'primary.main',
                                        fontWeight: 600,
                                        letterSpacing: 0.02,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {label}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, flexShrink: 0, ml: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '0.7rem', fontWeight: 600, color: statusHex }}>
                                    {statusName}
                                </Typography>
                                <ChevronRightIcon sx={{ fontSize: 20, color: 'action.disabled' }} />
                            </Box>
                        </>
                    );

                    const rowSx = {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        py: 0.75,
                        px: 0,
                    };

                    return svc.homeUrl ? (
                        <Link
                            key={`${subscriber._id}_${key}`}
                            to={`${buildURL(`/subscribers/${subscriber._id}`, svc.homeUrl || '')}`}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <Box sx={rowSx}>{inner}</Box>
                        </Link>
                    ) : (
                        <Box key={`${subscriber._id}_${key}`} sx={rowSx}>
                            {inner}
                        </Box>
                    );
                })}
            </Stack>
        </Box>
    );
};

export default DashboardMyAccountsServicesList;
